export const optionsTime = [
  {
    title: "09:00 AM",
    value: "09:00 AM",
  },
  {
    title: "10:00 AM",
    value: "10:00 AM",
  },
  {
    title: "11:00 AM",
    value: "11:00 AM",
  },
  {
    title: "12:00 PM",
    value: "12:00 PM",
  },
  {
    title: "01:00 PM",
    value: "01:00 PM",
  },
];
export const optionsDays = [
  {
    title: "01",
    value: "01",
  },
  {
    title: "03",
    value: "03",
  },
  {
    title: "05 ",
    value: "05",
  },
];
